var comp = 'angle-input';
export var dataHooks = {
  numericInput: "numeric-input-".concat(comp),
  knob: "knob-".concat(comp)
};